import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { X } from "@phosphor-icons/react";

export default function ProductPicker({ value, onChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (value || q.trim().length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get("/products", { params: { q: q.trim(), limit: 8 } }).then((r) => setResults(r.data || [])).catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q, value]);

  if (value) {
    return (
      <div data-testid="review-product-selected" className="flex items-center gap-3 border border-border rounded-sm p-2">
        {value.default_image && <img src={value.default_image} alt="" className="w-10 h-10 rounded-sm object-cover" />}
        <span className="text-sm flex-1 truncate">{value.title}</span>
        <button type="button" data-testid="review-product-clear" onClick={() => onChange(null)} className="p-1 text-muted-foreground hover:text-[#C84A31]" aria-label="Change product">
          <X size={14} />
        </button>
      </div>
    );
  }
  return (
    <div className="relative">
      <Input data-testid="review-product-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search for the item you bought…" className="rounded-sm" />
      {results.length > 0 && (
        <div className="absolute z-20 left-0 right-0 mt-1 bg-white border border-border rounded-sm shadow-lg max-h-64 overflow-auto">
          {results.map((p) => (
            <button key={p.id} type="button" data-testid={`review-product-option-${p.id}`} onClick={() => onChange(p)}
              className="w-full flex items-center gap-3 p-2 text-left hover:bg-muted transition-colors">
              {p.default_image && <img src={p.default_image} alt="" className="w-9 h-9 rounded-sm object-cover" />}
              <span className="text-sm truncate">{p.title}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
